import React from 'react'
import styles from "./Styles.module.css";
import { ButtonBase, Icon, Typography } from "@mui/material";
import StatusPill from "../../../components/Status/StatusPill.component";
import history from "../../../libs/history.utils";
import { Add, ArrowBackIos, Lock } from "@mui/icons-material";
import {
  ArrowPrimaryButton,
  OutlineButton,
  PrimaryButton,
} from "../../../components/Buttons/PrimaryButton";
import capitalizeFirstLetter from "../../../hooks/CommonFunction";
import editTask from "../../../assets/CRMAssets/ic_edit@2x.png";
import useAdminUsersDetail from "./AdminUsersDetail.hook";
import StarsIcon from '@mui/icons-material/Stars';
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import AssociatedProgramsListTable from './components/AssociatedPrograms/AssociatedProgramsList.view';
import AssociatedClientsList from './components/AssociatedClients/AssociatedClientsList.view';
import useRoles from '../../../hooks/RoleHook';
import Constants from '../../../config/constants';

const AdminUsersDetail = () => {
const {programDetails, adminDetails, getInitials, handleEdit} = useAdminUsersDetail({});
const {canRead, canCreate, canUpdate} = useRoles(Constants.MODULES.ADMIN_USERS);
const getStatusPillColor = () => {
  if (adminDetails?.status === "ACTIVE") {
    return "active";
  } else if (adminDetails?.status === "INACTIVE") {
    return "high";
  }
};

  return (
    <div>
      <div className={styles.upperFlex}>
       
          <ButtonBase onClick={() => history.push("/client/user")}>
            <ArrowBackIos fontSize={"small"} />{" "}
            <span>
              <Typography variant={"h4"}>Profile View</Typography>
            </span>
          </ButtonBase>
          <div></div>
          <div className={styles.profileHeading}></div>
          <div className={styles.buttonRow}>
          {/* <OutlineButton
              // onClick={() => {
              //   handleEdit();
              // }}
            >
              MANAGE PRIVILEGES
              <span className={styles.imageContainer}>
                <Icon className={styles.binImage}><StarsIcon/></Icon>
              </span>
            </OutlineButton>
            {canUpdate &&<OutlineButton
              onClick={() => {
                handleEdit();
              }}
            >
              EDIT
              <span className={styles.imageContainer}>
                <img
                  src={editTask}
                  alt="task"
                  width={20}
                  height={20}
                  className={styles.binImage}
                />
              </span>
            </OutlineButton>} */}
          </div>
         
        </div>
        <div className={styles.row}>
          <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <div className={styles.row}>
                <div className={styles.contactImg}><Typography color={"primary"} variant="h1">{getInitials(adminDetails?.name)}</Typography></div>
                
                  <div className={styles.textContainer}>
                    <div className={styles.row1}>
                      <Typography
                        variant={"h5"}
                        className={styles.productHeading}
                        color={"text.primary"}
                      >
                       {capitalizeFirstLetter(adminDetails?.name)}
                      </Typography>
                      <div className={styles.right}>
                        <StatusPill
                          status={
                            adminDetails?.status === "INACTIVE"
                              ? "Inactive"
                              : "Active"
                          }
                          color={getStatusPillColor()}
                        />
                      </div>
                    </div>
                    
                    
                    <div className={styles.row}>
                      <>
                        <Typography
                          variant={"body1"}
                          color={"text.secondary"}
                          className={styles.spacing}
                        >
                          Email:
                        </Typography>
                        <Typography
                          variant={"subtitle1"}
                          color={"text.secondary"}
                          sx={{ ml: 1 }}
                        >
                        
                        {adminDetails?.email}
                        </Typography>
                      </>
                    </div>
                    <div className={styles.row}>
                      <Typography
                        variant={"body1"}
                        color={"text.secondary"}
                        className={styles.spacing}
                      >
                        Type:
                      </Typography>
                      <Typography
                        variant={"subtitle1"}
                        color={"text.secondary"}
                        sx={{ ml: 1 }}
                      >
                        {adminDetails?.type === "ADMIN" ? "Admin" : adminDetails?.type === "CLIENT_USER" ? "Client User" : "N/A"}
                      </Typography>
                    </div>
                    <div className={styles.row}>
                      <Typography
                        variant={"body1"}
                        color={"text.secondary"}
                        className={styles.spacing}
                      >
                        Role:
                      </Typography>
                      <Typography
                        variant={"subtitle1"}
                        color={"text.secondary"}
                        sx={{ ml: 1 }}
                      >
                         {/* {adminDetails?.role ? adminDetails?.role : "N/A"} */}
                         {capitalizeFirstLetter(Object.keys(adminDetails?.role || {}).length === 0 ? "N/A" : adminDetails?.role?.name)}

                      </Typography>
                    </div>
                    <div className={styles.row}>
                      <Typography
                        variant={"body1"}
                        color={"text.secondary"}
                        className={styles.spacing}
                      >
                        Client:
                      </Typography>
                      <Typography
                        variant={"subtitle1"}
                        color={"text.secondary"}
                        sx={{ ml: 1 }}
                      >
                        {capitalizeFirstLetter(adminDetails?.clients?.map(client => client.name).join(", ") || "N/A")}
                      </Typography>
                    </div>
                    {/* <div className={styles.row}>
                      <Typography
                        variant={"body1"}
                        color={"text.secondary"}
                        className={styles.spacing}
                      >
                       Is Approver:
                      </Typography>
                      <Typography
                        variant={"subtitle1"}
                        color={"text.secondary"}
                        sx={{ ml: 1 }}
                      >
                        {adminDetails?.is_approver ? "Yes" : "No"}
                      </Typography>
                    </div> */}
                   
                    
                  </div>
                  
                </div>

                <div className={styles.line}></div>
                <Typography
                        variant={"h5"}
                        className={styles.activity}
                        color={"text.primary"}
                       
                      >
                       Activity Information
                      </Typography>
                      <div className={styles.gridContainer}>
                      <div className={styles.reporterDetails}>
                      <Typography variant="body1" color={"text.secondary"}>
                      Created On: <strong>{adminDetails?.createdAtText ?? "N/A"}</strong>
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}sx={{mt:1}}>
                  Updated On:{" "}
                    <strong>{adminDetails?.updatedAtText ?? "N/A"}</strong>
                  </Typography>
                      
                      </div>
                      <div className={styles.patientDetails}>
                      <Typography variant="body1" color={"text.secondary"}>
                      Last Login: <strong>{adminDetails?.lastLoginText ?? "N/A"}</strong>
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"} sx={{mt:1}}>
                  Updated By:{" "}
                    <strong>{capitalizeFirstLetter(adminDetails?.updated_by?.name ?? "N/A")}</strong>
                  </Typography>
                      </div>
                      </div>
              </div>
            </ShadowBox>
        </div>
        {adminDetails?.type==="ADMIN" && (
          <ShadowBox className={styles.product}>
         <AssociatedClientsList/>
        </ShadowBox>
      )}
      {adminDetails?.type==="CLIENT_USER" && (
        <ShadowBox className={styles.product}>
       
        <AssociatedProgramsListTable/>
        </ShadowBox>
      )}
   
    </div>
  )
}

export default AdminUsersDetail